import { normalizePlanName } from "./planFeatureAccess";

export const TRIAL_PRICE_IDS = new Set(["price_1THlgvA1DZhFpfbJFAzeGQmy"]);

export const STRIPE_PLAN_LABEL_BY_PRICE_ID = {
  price_1TGcrxA1DZhFpfbJ9gkHITBm: "BASIC_MONTH",
  price_1TGcrtA1DZhFpfbJRAw0m1W8: "BASIC_YEAR",
  price_1TGcrnA1DZhFpfbJk7DUzJbg: "PREMIUM_MONTH",
  price_1TGcroA1DZhFpfbJ2U3ryGXo: "PREMIUM_YEAR",
  price_1TGcrnA1DZhFpfbJ01zwwMlU: "ULTIMATE_MONTH",
  price_1TGcrnA1DZhFpfbJlcjRF0Bm: "ULTIMATE_YEAR",
  price_1THlgvA1DZhFpfbJFAzeGQmy: "TRIAL",
};

const toTitle = (value = "") =>
  String(value)
    .split("_")
    .map((part) => (part ? part.charAt(0) + part.slice(1).toLowerCase() : part))
    .join(" ");

export const getOrganizationDisplayPlan = (org = {}, organizationsStats = []) => {
  const stripePlanId = org?.OrganizationPlan?.stripe_plan_id || null;
  const rawPlanName = org?.OrganizationPlan?.plan_name || org?.OrganizationPlan?.title || "";
  const stripeStatus = String(org?.stripe_status || "").toLowerCase();
  const isStripeManagedOrg =
    String(org?.plan_changed_by || "").toUpperCase() !== "SUPER_ADMIN" &&
    Boolean(org?.subscription_id || org?.stripe_customer_id || stripePlanId);
  const orgPaymentEntry = Array.isArray(organizationsStats)
    ? organizationsStats.find((entry) => Number(entry?.org_id) === Number(org?.id))
    : null;
  const orgPurchaseCount = Number(orgPaymentEntry?.total_purchases || 0);
  const isTrialByPlanName = String(rawPlanName).toLowerCase().includes("trial");
  const isLikelyUnpaidStripeTrial =
    isStripeManagedOrg &&
    orgPurchaseCount === 0 &&
    ["trialing", "active", ""].includes(stripeStatus);
  const isTrialPlan =
    TRIAL_PRICE_IDS.has(stripePlanId) ||
    stripeStatus === "trialing" ||
    isTrialByPlanName ||
    isLikelyUnpaidStripeTrial;
  const normalizedPlanName = isTrialPlan ? "trial" : normalizePlanName(rawPlanName);
  const exactStripePlanLabel = stripePlanId ? STRIPE_PLAN_LABEL_BY_PRICE_ID[stripePlanId] : null;
  const code = isTrialPlan
    ? "TRIAL"
    : exactStripePlanLabel || (normalizedPlanName ? String(normalizedPlanName).toUpperCase() : "N/A");

  return {
    code,
    title: toTitle(code),
    stripePlanId,
    isTrialPlan,
  };
};

